// Astarte-on-glitch: live MathJax preview of the composed text.
// Shown only while the text contains TeX math delimiters. The old fork's
// version crashed on an undefined variable (which is why it had been
// disabled); this one renders the text as plain text (no raw HTML) into a
// ref'd node that MathJax then typesets, keeping React out of the mutated
// subtree.

import { useEffect, useRef, useState } from 'react';

import { containsMath, typesetMath } from '@/astarte/mathjax';

const DEBOUNCE_MS = 375;

export const AstarteLivePreview: React.FC<{ text: string }> = ({ text }) => {
  const [debouncedText, setDebouncedText] = useState(text);
  const nodeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedText(text);
    }, DEBOUNCE_MS);

    return () => {
      clearTimeout(timeout);
    };
  }, [text]);

  useEffect(() => {
    const node = nodeRef.current;

    if (!node) {
      return;
    }

    node.textContent = debouncedText;
    typesetMath(node, debouncedText);
  }, [debouncedText]);

  if (!containsMath(text)) {
    return null;
  }

  return <div className='compose-form__live-preview' ref={nodeRef} />;
};
